export type UserPremiumStatus = {
  hasPremium: boolean;
  purchaseDate?: number;
  licenseKey?: string;
  expiryDate?: number;
};

const PREMIUM_STATUS_KEY = 'lofi-premium-status';

// Simple mock license validation
const VALID_LICENSE_KEYS = [
  'PREMIUM-2024-VALID',
  'LOFI-PRO-LICENSE',
  'DEVELOPER-TEST-KEY',
];

export const getPremiumStatus = (): UserPremiumStatus => {
  try {
    const stored = localStorage.getItem(PREMIUM_STATUS_KEY);
    if (stored) {
      const status = JSON.parse(stored) as UserPremiumStatus;
      // Check if license is still valid
      if (status.expiryDate && status.expiryDate < Date.now()) {
        return { hasPremium: false };
      }
      return status;
    }
  } catch (error) {
    console.warn('Failed to parse premium status:', error);
  }
  
  return { hasPremium: false };
};

export const setPremiumStatus = (status: UserPremiumStatus): void => {
  try {
    localStorage.setItem(PREMIUM_STATUS_KEY, JSON.stringify(status));
  } catch (error) {
    console.warn('Failed to save premium status:', error);
  }
};

export const validateLicenseKey = (licenseKey: string): boolean => {
  return VALID_LICENSE_KEYS.includes(licenseKey);
};

export const activatePremium = (licenseKey: string): boolean => {
  if (validateLicenseKey(licenseKey)) {
    const status: UserPremiumStatus = {
      hasPremium: true,
      purchaseDate: Date.now(),
      licenseKey,
      // Set expiry to 1 year from now (for demo purposes)
      expiryDate: Date.now() + (365 * 24 * 60 * 60 * 1000),
    };
    setPremiumStatus(status);
    return true;
  }
  return false;
};

export const deactivatePremium = (): void => {
  setPremiumStatus({ hasPremium: false });
};

export const canUsePremiumItem = (itemTier: 'base' | 'premium'): boolean => {
  if (itemTier === 'base') return true;
  return getPremiumStatus().hasPremium;
};

// For demo purposes - activate premium with a simple flag
export const togglePremiumForDemo = (): boolean => {
  const current = getPremiumStatus();
  if (current.hasPremium) {
    deactivatePremium();
    return false;
  } else {
    activatePremium('DEVELOPER-TEST-KEY');
    return true;
  }
}; 